import { moment } from '../lib/moment';
import { Range } from '../model/devicesTestingForm';
import * as keyset from 'i18n/DraftControlPanel';
import i18n from '@yandex-int/i18n';

const t = i18n(keyset);

export const padZero = (n: number) => (n >= 0 && n < 10 ? `0${n}` : `${n}`);

export const formatSecondsForDuration = (totalSeconds: number) => {
    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds -= hours * 3600;

    const minutes = Math.floor(totalSeconds / 60);
    totalSeconds -= minutes * 60;

    const seconds = Math.floor(totalSeconds);

    if (hours === 0) {
        return `${minutes}:${padZero(seconds)}`;
    }

    return `${hours}:${padZero(minutes)}:${padZero(seconds)}`;
};

const { meetingDurationMinutes, utcOffset, workingDays, workingHours } = __appConfig.devicesTestingDateConfig;

const isHolidays = (date: moment.Moment) => {
    if (date.month() === 11) {
        return date.date() === 31;
    } else if (date.month() === 0) {
        return [1, 2, 3, 4, 5, 6, 7, 8].includes(date.date());
    } else {
        return false;
    }
};

const checkDateValidity = (date: moment.Moment, lowerBoundDate: moment.Moment) => {
    return (
        !isHolidays(date) &&
        date.hours() >= workingHours.start &&
        date.hours() < workingHours.end &&
        date.valueOf() >= lowerBoundDate.valueOf() &&
        workingDays[date.day()]
    );
};

const calculateDaysInSchedule = (startDate: moment.Moment) => {
    return 14 - (((startDate.day() + 6) % 7) + 1);
};

export const formatDevicesTestingRange = ({ fromMs, toMs }: Range, withDate: boolean = false) => {
    const timeStr = `${t('time-since')}\xa0${moment(fromMs)
        .utcOffset(utcOffset)
        .format('HH:mm')} ${t('time-till')}\xa0${moment(toMs).utcOffset(utcOffset).format('HH:mm')} ${t('time-msk')}`;

    return withDate ? `${moment(fromMs).utcOffset(utcOffset).format('DD.MM.YYYY')}\xa0${timeStr}` : timeStr;
};

export const generateTestingHours = (currentDate: moment.Moment) => {
    const lowerBoundDate = moment(currentDate)
        .add(1, 'days')
        .hours(10)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
        .utcOffset(utcOffset);

    const ranges: Record<string, Range[]> = {};
    const rangesOrder: string[] = [];

    let meetingStartDate = lowerBoundDate.clone();

    const scheduleDays = calculateDaysInSchedule(meetingStartDate);

    const upperBoundDate = moment(meetingStartDate).add(scheduleDays, 'days');

    while (upperBoundDate.isSameOrAfter(meetingStartDate)) {
        const meetingEndDate = moment(meetingStartDate).add(meetingDurationMinutes, 'minutes');

        if (checkDateValidity(meetingStartDate, lowerBoundDate)) {
            const formattedDayLabel = meetingStartDate.format('DD.MM.YYYY — dddd');

            if (ranges[formattedDayLabel]) {
                ranges[formattedDayLabel].push({
                    fromMs: meetingStartDate.valueOf(),
                    toMs: meetingEndDate.valueOf(),
                });
            } else {
                ranges[formattedDayLabel] = [
                    {
                        fromMs: meetingStartDate.valueOf(),
                        toMs: meetingEndDate.valueOf(),
                    },
                ];
                rangesOrder.push(formattedDayLabel);
            }
        }

        meetingStartDate = meetingEndDate;
    }

    return [ranges, rangesOrder] as const;
};
